export default __webpack_public_path__ + "static/media/cyclopay-white-logo2.f58b6dac.png";